import { Button } from '@neo/index'
import { useState } from 'react'
import type { EvalTestCase } from '../types'
import { ConversationTimelineModal } from './conversation-timeline-modal'
import { MetricRow } from './metric-row'

interface TestCaseDetailsProps {
  testCase: EvalTestCase
}

export const TestCaseDetails = ({ testCase }: TestCaseDetailsProps) => {
  const [isTimelineModalOpen, setIsTimelineModalOpen] = useState(false)

  return (
    <div className="ml-8 pl-2  pr-2 pb-2 space-y-2 bg-bg2 rounded-lg p-3">
      {/* View Conversation Timeline Link */}
      {testCase.conversationHistory && (
        <div className="flex justify-end">
          <Button
            variant="ghost"
            className="underline"
            size="xs"
            onClick={() => setIsTimelineModalOpen(true)}
            data-testid="view-conversation-timeline"
          >
            View Conversation Timeline
          </Button>
        </div>
      )}

      {/* Metrics */}
      {testCase.metrics && testCase.metrics.length > 0 && (
        <div className="space-y-1">
          {testCase.metrics.map((metric) => (
            <MetricRow
              key={metric.name}
              metric={metric}
              actualResponse={testCase.actualResponse}
              expectedResponse={testCase.expectedResponse}
            />
          ))}
        </div>
      )}

      {/* Conversation Timeline Modal */}
      <ConversationTimelineModal
        isOpen={isTimelineModalOpen}
        onClose={() => setIsTimelineModalOpen(false)}
        testCase={testCase}
      />
    </div>
  )
}
